module.exports = __webpack_public_path__ + "img/icon_school.03157f8.svg";